<ng-container *ngFor="let key of emailAddressKeys">
  <div
    *ngIf="!!log && hasLog(key, log)"
    [innerHTML]="normalizeLog(key, log) | changeLogsDiffHTML : emailAddressLookup : (getLookup(key) | async)"
  ></div>
</ng-container>
